// Volání /api/sales ze sales sekce. Chyba ze serveru se vrací jako Error s českou zprávou.
import { apiFetch } from "../../lib/api.js";

export async function salesGet(akce, params = {}) {
  const q = new URLSearchParams({ akce, ...Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")) });
  const r = await apiFetch(`/api/sales?${q.toString()}`);
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || `Chyba ${r.status}`);
  return j;
}

export async function salesPost(akce, body = {}) {
  const r = await apiFetch("/api/sales", { method: "POST", body: JSON.stringify({ akce, ...body }) });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || `Chyba ${r.status}`);
  return j;
}

// Stopky: když paní začne hovor a měření neběží, spustí se samo s činností Sales.
export async function spustMereniSales() {
  try {
    const r = await apiFetch("/api/time-report");
    if (!r.ok) return false;
    const j = await r.json();
    if (j.running) return false;
    const s = await apiFetch("/api/time-report", { method: "POST", body: JSON.stringify({ action: "start", oblast: "Sales", popis: "Volání (spuštěno samo)" }) });
    if (!s.ok) return false;
    window.dispatchEvent(new Event("fw40-time-changed"));
    return true;
  } catch { return false; }
}
export async function stavMereni() {
  try {
    const r = await apiFetch("/api/time-report");
    if (!r.ok) return null;
    const j = await r.json();
    return j.running || null;
  } catch { return null; }
}
export async function zastavMereni() {
  const r = await apiFetch("/api/time-report", { method: "POST", body: JSON.stringify({ action: "stop" }) });
  window.dispatchEvent(new Event("fw40-time-changed"));
  return r.ok;
}

// ─── datumy ───────────────────────────────────────────────────────────────
const DNY = ["", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota", "neděle"];
const DNY_KRATCE = ["", "po", "út", "st", "čt", "pá", "so", "ne"];
export function dowOf(iso) { const [y, m, d] = String(iso).split("-").map(Number); const js = new Date(Date.UTC(y, m - 1, d)).getUTCDay(); return js === 0 ? 7 : js; }
export function addDays(iso, n) { const [y, m, d] = String(iso).split("-").map(Number); return new Date(Date.UTC(y, m - 1, d + n)).toISOString().substring(0, 10); }
export function dnesIso() { const d = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Prague" })); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; }
export function pondeli(iso) { return addDays(iso, 1 - dowOf(iso)); }
export function dm(iso) { if (!iso) return ""; const [, m, d] = String(iso).substring(0, 10).split("-").map(Number); return `${d}. ${m}.`; }
export function dmr(iso) { if (!iso) return ""; const [y, m, d] = String(iso).substring(0, 10).split("-").map(Number); return `${d}. ${m}. ${y}`; }
export function denKratce(iso) { return `${DNY_KRATCE[dowOf(iso)]} ${dm(iso)}`; }
export function denDlouze(iso) { return `${DNY[dowOf(iso)]} ${dm(iso)}`; }
export function casBezNuly(c) { return String(c || "").replace(/^0(\d)/, "$1"); }
export function kdyText(iso) {
  if (!iso) return "";
  const dnes = dnesIso();
  if (iso === dnes) return "dnes";
  if (iso === addDays(dnes, 1)) return "zítra";
  if (iso === addDays(dnes, -1)) return "včera";
  return denKratce(iso);
}
// Čas události (ISO timestamp) → { den: "čt 1. 10.", cas: "16:30" } v Praze.
export function kdyUdalost(ts) {
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return { den: "", cas: "" };
  const p = new Date(d.toLocaleString("en-US", { timeZone: "Europe/Prague" }));
  const iso = `${p.getFullYear()}-${String(p.getMonth() + 1).padStart(2, "0")}-${String(p.getDate()).padStart(2, "0")}`;
  return { den: denKratce(iso), cas: `${p.getHours()}:${String(p.getMinutes()).padStart(2, "0")}`, iso };
}
export function telefonHezky(t) { const c = String(t || "").replace(/\D/g, "").slice(-9); return c.length === 9 ? `${c.slice(0, 3)} ${c.slice(3, 6)} ${c.slice(6)}` : String(t || ""); }
export { DNY, DNY_KRATCE };
